import { Card, ListGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useMutation } from "@apollo/client";

import ChatRoom from "./ChatRoom";
import { READ_MESSAGE } from "../../../graphql/mutations/message";
import { setCurrentChat } from "../redux/chatSlice";
import { useQueryAllNotifications } from "../../../graphql/apollo/query-hooks";
import { showErrorToast } from "../../../components/common/CustomErrorMessage";

const ChatRoomList = ({ data, loadMessages }) => {
  const dispatch = useDispatch();
  const { refetch } = useQueryAllNotifications();

  const [readMessage] = useMutation(READ_MESSAGE, {
    onCompleted: (data) => {
      if (data.readMessages) {
        refetch();
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  const handleSetCurrentChat = (chatRoom) => {
    loadMessages();
    dispatch(setCurrentChat(chatRoom));
    readMessage({ variables: { member: chatRoom.member.id } });
  };

  return (
    <Card className="room-list">
      <ListGroup>
        {data?.map((room) => {
          return (
            <ListGroup.Item
              key={room.id}
              onClick={() => handleSetCurrentChat(room)}
            >
              <ChatRoom room={room} />
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </Card>
  );
};

export default ChatRoomList;
